const state = {
  list: [],
  bidsList: [],
  firstInTransporterList: [],
  isLoading: false,
  isUploading: false,
  isPaginating: false,
  filter: {},
  hasEmpty: false,
  parentList: {},
  canShowSaveGRN: false,
  userEdited: false,
  warnedOnce: false,
  returnMaterialDetails: {},
  returnMaterialsWarnedOnce: false,
  indentRepublishRequests: [],
};

export default state;
